function getFilesWebkitDataTransferItems(dataTransferItems) {
  function traverseFileTreePromise(item, path = '') {
    return new Promise((resolve) => {
      if (item.isFile) {
        item.file((file) => {
          file.filepath = path + file.name; //save full path
          files.push(file);
          resolve(file);
        });
      } else if (item.isDirectory) {
        let dirReader = item.createReader();
        dirReader.readEntries((entries) => {
          let entriesPromises = [];
          for (let entr of entries) entriesPromises.push(traverseFileTreePromise(entr, path + item.name + '/'));
          resolve(Promise.all(entriesPromises));
        });
      }
    });
  }

  let files = [];
  return new Promise((resolve, reject) => {
    let entriesPromises = [];
    for (let it of dataTransferItems) entriesPromises.push(traverseFileTreePromise(it.webkitGetAsEntry()));
    Promise.all(entriesPromises).then((entries) => {
      resolve(files);
    });
  });
}

function getDirTreeFromFilePaths(paths) {
  let result = [];
  let level = { result };

  paths.forEach((path) => {
    path.split('/').reduce((r, name, i, a) => {
      if (name) {
        if (!r[name]) {
          r[name] = { result: [] };
          let isFile = false;
          let filePath;
          if (i === a.length - 1) {
            isFile = true;
            filePath = path;
          }
          r.result.push({ name, isFile, filePath, children: r[name].result });
        }

        return r[name];
      }
    }, level);
  });
  return result;
}

function getGroupedFilesByFolder(folders, files) {
  let result = [];
  files.forEach((file) => {
    const folder = folders.find((f) => f.path === file.filepath && f.type === 'file');
    if (folder) {
      const targetId = folder.parentId;
      if (!result[targetId]) {
        result[targetId] = { files: [] };
      }
      result[targetId].files.push(file);
    }
  });

  return result;
}

export { getFilesWebkitDataTransferItems, getDirTreeFromFilePaths, getGroupedFilesByFolder };
